import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function createUserIn2nAPI(user) {
  const url = `${AWS_API_URL}/2n/users`;

  return postRequest(url, {
    data: {
      name: user?.firstName,
      lastname: user?.lastName,
      email: encodeURI(user?.email),
    },
  }, await authorize());
}
